<template>
  <div class="leapin-empty">
    <img :src="emptySvg" alt="empty" />
    <span class="text">{{ text }}</span>
    <el-button @click="linkIntoProfile" type="primary" round v-if="showButton" class="btn btn-primary">Edit</el-button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'No data available'
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  name: 'Empty',
  data() {
    return {
      emptySvg: require('@/assets/svgs/empty.svg')
    }
  },
  mounted () {

  },
  methods: {
    linkIntoProfile() {
      this.$router.push({ path: '/CandidateShow' })
    }
  }
}
</script>

<style scoped lang="scss">
.leapin-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  border-radius: 16px;
  background: #FBFAFB;
  margin-bottom: 32px;
  width: 100%;
  padding-bottom: 32px;
  img {
    margin-top: 50px;
  }
  .text {
    color: #999;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 20px;
  }
}
</style>
